import React from "react";
import Layout from "../../layouts/index";
import ProofOfInsuranceScreen from "../../screens/onbording/ProofOfInsurance";

const ProofOfInsurance = () => {
  return (
    <Layout hideHeader={true} hideFooter={true}>
      <ProofOfInsuranceScreen />
    </Layout>
  );
};

export default ProofOfInsurance;
